export enum MarketDeviceStatus {
    OK = 'OK',
    NOT_FOUND = 'NOT_FOUND',
}

export interface MarketDevice {
    marketId: string;
    title: string;
    picture: string;
    testedWithAlice: boolean;
    isPublished: boolean;
    status: MarketDeviceStatus;
    vendorName: string;
    vendorId: number;
    categoryName: string;
    categoryId: number;
}
